import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import dateformat from "dateformat";

import { fetchDealRoomsForStakeholders } from "actions/meeting";

import _ from "lodash";
import cx from "classnames";
import styles from "./dealroom.module.scss";

import defaultCollection from "images/default_collection.jpeg";

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

export default function DealRoom({ handleClick }) {
  const dispatch = useDispatch();

  const dealRooms = useSelector((state) => _.get(state, "meeting.dealRooms.items") || []) || null;
  const user = useSelector((state) => _.get(state, "users.profile.item")) || {};
  const meetingContacts = useSelector((state) => _.get(state, "selection.meetingDetails.attendeeIds") || {});
  const loadingDealRooms = useSelector((state) => _.get(state, "meeting.dealRooms.loading") || false);
  const fetchedDealRooms = useSelector((state) => _.get(state, "meeting.dealRooms.fetched") || false);

  const [latestDealRoom, setLatestDealRoom] = useState({});

  useEffect(() => {

    const userEmailDomain = user.email ? user.email.split("@")[1] : null;
    const filteredEmails = meetingContacts.filter((email) => {
        const parts = email.split("@");
        const domain = parts.length > 1 ? parts[1] : null;
        return domain !== userEmailDomain;
      });

      dispatch(fetchDealRoomsForStakeholders(filteredEmails, 0, 20));
    
  }, [dispatch, user, meetingContacts]);

  useEffect(() => {
    if(_.size(dealRooms) > 0) {
      console.log("dealRooms", dealRooms);
      const latestDealRoom = _.maxBy(dealRooms, (dealRoom) =>
        new Date(dealRoom.modifiedDate).getTime()
      );
      setLatestDealRoom(latestDealRoom);
    }
  }, [dealRooms]);

  return (
    <>
      <div className={styles.header}>
        <i className="paperflite-deal-room" />
        Deal Room
      </div>
      <div className={styles.contentContainer}>

      {!loadingDealRooms && fetchedDealRooms && _.size(latestDealRoom) === 0 && (
        <div className={styles.createDealRoomContainer}>
          <div className={styles.title}>
          No deal room created yet for this deal
          </div>
          <a href={`${webAppUrl}/deal-rooms?source=chrome_extension`} target="_blank" rel="noopener noreferrer" className={styles.createButton}>
          <i className={cx(styles.arrowIcon, "paperflite-right-arrow")} />
          Create now
          </a>
        </div>
      )}
      {loadingDealRooms ? (
        <PlaceholderCard />
      ) : (
      _.size(latestDealRoom) > 0 && (
        <div className={styles.dealRoomCard}>
          <Image
            src={_.get(latestDealRoom, "icon.full") || defaultCollection}
            className={styles.dealRoomIcon}
            width={36}
            height={36}
          />
          
          <div className={styles.dealRoomDetails}>
            <div className={styles.name}>{latestDealRoom.name}</div>
            <div className={styles.peopleInvolved}>{latestDealRoom.totalPeopleInvolved} people involved</div>
            <div className={styles.lastModified}>
              last updated on {dateformat(latestDealRoom.modifiedDate, "dS mmm yyyy")}
            </div>
            <a 
            className={styles.openDealRoomButton} 
            target="_blank"
            href={`${webAppUrl}/deal-room/${latestDealRoom.dealRoomId}?source=chrome_extension`}
            rel="noopener noreferrer"
            >
              <i className={cx(styles.arrowIcon, "paperflite-right-arrow")} /> Open now
            </a>
          </div>
        </div>
      ))}
      </div>
    </>
  );
}

const PlaceholderCard = () => {
  return (
    <div className={styles.placeholderCard}>
      <div className={styles.placeholderIcon} />
      <div className={styles.placeholderInfo}>
        <div className={styles.placeholderTitle} />
        <div className={styles.placeholderDescription} />
      </div>
    </div>
  );
};
